import { render, staticRenderFns } from "./OpportunitiesQuery.vue?vue&type=template&id=6fe074e3&scoped=true"
import script from "./OpportunitiesQuery.vue?vue&type=script&lang=js"
export * from "./OpportunitiesQuery.vue?vue&type=script&lang=js"
import style0 from "./OpportunitiesQuery.vue?vue&type=style&index=0&id=6fe074e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe074e3",
  null
  
)

export default component.exports